"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
require("./Checkbox.pc.css");
const Checkbox = ({ onClick, className, checked, hover, error, boxOnTop, disabled, onChange, id, testId, }) => {
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('_f52d6672', '_90518bec', '_pub-90518bec', '_90518bec_checkbox', '_pub-90518bec_checkbox', 'checkbox', {
            '_90518bec_checked _pub-90518bec_checked checked': checked,
            '_90518bec_hover _pub-90518bec_hover hover': hover,
            '_90518bec_error _pub-90518bec_error error': error,
            '_90518bec_boxOnTop _pub-90518bec_boxOnTop boxOnTop': boxOnTop,
            '_90518bec_disabled _pub-90518bec_disabled disabled': disabled,
        }, className), onClick: onClick, "data-testid": "checkbox" },
        react_1.default.createElement("input", { className: (0, clsx_1.default)('_89f5621e', '_90518bec', '_pub-90518bec'), type: "checkbox", checked: checked, disabled: disabled, onChange: onChange, id: id, "data-testid": testId }),
        react_1.default.createElement("div", { className: (0, clsx_1.default)('_67fb0332', '_90518bec', '_pub-90518bec') },
            react_1.default.createElement("div", { className: (0, clsx_1.default)('_44542a1a', '_90518bec', '_pub-90518bec') }))));
};
exports.Checkbox = Checkbox;
//# sourceMappingURL=Checkbox.pc.js.map